import { Component } from "solid-js";
import { setHeaderContent } from "../app";

export const SectionHeader : Component<any> = (props) => {
    setHeaderContent(props.children);
    return (<></>)
}